var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { SliceOnboardingSection } from './slice-onboarding-section';
import { OnboardingSelectionStep } from '../elements';
import { useObjectives } from '../hooks/use-objectives';
var cls = classNames('slice-onboarding-objectives-grid');
export var SliceOnboardingObjectivesGridDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  "])), theme.UNIT(10))
});
var SelectionGridStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'SliceOnboardingObjectivesGrid',
  Container: styled(SliceOnboardingSection)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  SelectionGrid: styled(OnboardingSelectionStep)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), SelectionGridStyles)
};
export var SliceOnboardingObjectivesGrid = function (props) {
  var _a = useComponentProps(My.NAME, SliceOnboardingObjectivesGridDefaultProps, props),
    className = _a.className,
    children = _a.children,
    entity = _a.entity;
  var objectives = useObjectives();
  if (!objectives.length) {
    return null;
  }
  ;
  return React.createElement(My.Container, {
    className: cls.name(className),
    entity: entity
  }, React.createElement(My.SelectionGrid, {
    items: objectives,
    entityKey: 'Objective'
  }), children);
};
SliceOnboardingObjectivesGrid.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;